import { render, staticRenderFns } from "./jbxxBanKuai.vue?vue&type=template&id=5aab7ec6&scoped=true"
import script from "./jbxxBanKuai.vue?vue&type=script&lang=js"
export * from "./jbxxBanKuai.vue?vue&type=script&lang=js"
import style0 from "./jbxxBanKuai.vue?vue&type=style&index=0&id=5aab7ec6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aab7ec6",
  null
  
)

export default component.exports